module.exports = __webpack_public_path__ + "img/call-to-action.8f9f98aa.jpg";